import { Component, Input } from '@angular/core';
import { Expediente } from '@models/expediente.model';
import { Sancion } from '@models/sancion.model';

@Component({
	selector: 'app-sancion',
	templateUrl: './sancion.component.html',
	styleUrls: ['./sancion.component.scss']
})
export class SancionComponent {
	@Input() Expediente: Expediente;

	readonly mensajeAlerta: string = "Expediente sin sanción previa aplicada"
	get sancion(): Sancion | null {
		return this.Expediente?.sancion ?? null;
	}
}
